/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-unused-vars */

import * as Sentry from '@sentry/browser';
import { BrowserTracing } from '@sentry/tracing';
/** 
 * @author yhbae 
 * @see 웹 로깅을 위한 라이브러리
 * info: 일반적인 정보, 개발환경에서만 표시됨
 * warn: 노티를 보내야 하는 정보
 * error: 심각한 에러, 바로 노티를 보내야 하는 정보
 * exception: error 와 동일 
 * 개발에 필요한 로깅은 console.log() 에 적는다. 번들링된 결과물에는 사라짐
 * {@link ://github.com/getsentry/sentry-javascript/tree/master/packages/browser}
 * </pre>
 */

let displayDebugLog = false;
let displayInfoLog = false;
let displayWarnLog = true;
let displayErrorLog = true;

let sendServerDebugLog = false;
let sendServerInfoLog = false;
let sendServerWarnLog = false;
let sendServerErrorLog = false;

export default {
    mode: 'prod',
    /** @author yhbae @see 모듈 호출시 반드시 초기화 후 시작한다. */
    init: function (mode: string): void {
        try {
            if(mode) this.mode = mode;
            console.log('INIT LOGGER MODE:', mode);
            
            if (['local', 'dev'].includes(mode)) {
                displayDebugLog = true;
                displayInfoLog = true;
                displayWarnLog = true;
                displayErrorLog = true;

            } else if ('sandbox' == mode) {
                displayInfoLog = true;
                displayWarnLog = true;
                displayErrorLog = true;

                //sendServerInfoLog = true;
                //sendServerWarnLog = true;
                //sendServerErrorLog = true;
            } else {
                displayWarnLog = true;
                displayErrorLog = true;

                //sendServerWarnLog = true;
                //sendServerErrorLog = true;
            }
            
            /* Sentry 웹 로깅을 초기화 한다. */
            //if(location.protocol == 'http:' || location.protocol == 'https:') {
            //    Sentry.init({
            //        dsn: location.protocol + '//d0b909aded7c4104a8a38e938b3c5f76@112.175.55.92:22090/3',
            //        // Alternatively, use `process.env.npm_package_version` for a dynamic release version
            //        // if your build tool supports it.
            //        release: 'cy_cko@1',
            //        environment: mode.includes('prod') ? 'production' : mode.includes('sandbox') ? 'sandbox' : mode, // 환경을 나눌수 있습니다
            //        enabled: true,
            //        sampleRate: 1,
            //        tracesSampleRate: 1.0,
            //        integrations: [new BrowserTracing()],
            //        // tracingOptions: { // 하위 구성 요소를 추적하고 렌더링 프로세스에 대한 자세한 내용을 보기
            //        //  trackComponents: true
            //        // }
            //        // Set tracesSampleRate to 1.0 to capture 100%
            //        // of transactions for performance monitoring.
            //        // We recommend adjusting this value in production
            //    });
            //}
        } catch (error) {
            console.info('cyrexpay logging fail:', error);
        }
    },
    /** @author yhbae @see 개발 로깅(개발환경에서만 표시된다, 가맹점에는 절대 표시 되지 않아야 한다.) */
    debug: function (...params: unknown[]): void {
        if (displayDebugLog) {
            console.log(...params);
        }
        if (sendServerDebugLog) {
            Sentry.captureMessage(JSON.stringify(params), {
                level: 'info', // one of 'info', 'warning', or 'error'
            });
        }
    },
    /** @author yhbae @see 일반적인 로깅(개발환경에서만 표시된다) */
    // @typescript-eslint/no-explicit-any
    info: function (...params: unknown[]): void {
        if (displayInfoLog) {
            console.log(...params);
        }
        if (sendServerInfoLog) {
            console.log('-=-=-=-=--==--==---===---===----====----====-----=====-----=====------======------======');
            Sentry.captureMessage(JSON.stringify(params), {
                level: 'info', // one of 'info', 'warning', or 'error'
            });
        }
    },
    /** @author yhbae @see 경고상황 로깅(모든 콘솔에 표시) */
    warn: function (...params: unknown[]): void {
        if(displayWarnLog) {
            console.warn(...params);
        }
        if (sendServerWarnLog) {
            Sentry.captureMessage(JSON.stringify(params), {
                level: 'warning', // one of 'info', 'warning', or 'error'
            });
        }
    },
    /** @author yhbae @see 에러상황 로깅(모든 콘솔에 표시, 웹로깅으로 노티전송)*/
    error: function (...params: unknown[]): void {
        if(displayErrorLog) {
            console.error(...params);
        }
        if (sendServerErrorLog) {
            Sentry.captureMessage(JSON.stringify(params), {
                level: 'error', // one of 'info', 'warning', or 'error'
            });
        }
    },
    /** @author yhbae @see 에러상황 로깅(모든 콘솔에 표시, 웹로깅으로 노티전송)
     * @param string    에러 메시지
     * @param Error     Catched Exception object
     */
    exception: function (msg: string, error: Error | unknown): void {
        if(displayErrorLog) {
            console.error(msg, error);
        }
        if (sendServerErrorLog) {
            Sentry.captureException(error);
        }
    },
    tag: function (prefix: string, color?: string) {
        if (!prefix) prefix = '';
        let backg = '97'
        let forg = '44';
        if (color == 'red') {
            backg = '97';
            forg = '41';
        } else if (color == 'yellow') {
            backg = '30';
            forg = '103';
        } else if (color == 'green') {
            backg = '30';
            forg = '102';
        } else if (color == 'gray') {
            backg = '97';
            forg = '47';
        }
        return `\x1B[${forg};${backg};2m ${prefix} `;
    }
};


